import { CommonService } from './../../../../services/utils/common.service';
import { ProvinceService } from './../../../../services/province/province.service';
import { CountryService } from './../../../../services/country/country.service';
import { Report } from './../../../../models/report.model';
import { StoreCommonService } from './../../../../services/store/store-common.service';
import { TranslateService } from '@ngx-translate/core';
import { CustomerCardListModel } from './../../../../models/customer-cards.model';
import { mgCustomer, CustomerBasicInfo, CustomerFileUpload } from './../../../../models/customer.model';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { CustomerInfoService } from './../../../../services/customer/customerinfo.service';
import { FileUpload, MessageService, SelectItem } from 'primeng/primeng';

import { Component, EventEmitter, Input, OnInit, Output, ElementRef, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { format } from 'url';
import { LoyaltyReservationsService } from 'app/services/loyalty/loyalty-reservations.service';

declare var Stimulsoft: any;
declare var $: any;

@Component({
  selector: 'app-upload-mg',
  templateUrl: './uploadmg.component.html',
  providers: [],
})
export class Uploadmg implements OnInit {

  @Input() customerHostId: string;
  @Input() basicInfo: CustomerBasicInfo;
  @ViewChild('upload') upload: FileUpload;

  file: File = null;

  currentExistingFiles: Array<CustomerFileUpload> = new Array<CustomerFileUpload>();

  viewer: any;
  pdfReport: Report;
  translations: any;
  customer:mgCustomer;
  card: CustomerCardListModel;
  show = {
    customerInfo: false,
    available: false,
    download: false
  }
  provinces: SelectItem[] = [];
  barcodeCardNo: string = '';
  cardInfo: Array<CustomerCardListModel>;

  @Output() customerHasFiles: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private notifyService: MessageService,
    private srvCust: CustomerInfoService,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private srvStoreCommon: StoreCommonService,
    private srvCountry: CountryService,
    private srvProvince: ProvinceService,
    private srvLoyaltyReservations: LoyaltyReservationsService  ,
    private srvCommon: CommonService  
  ) { }
  ngOnInit(): void {    

    const translateObs = this.translate.get([
      'common.all',
      'common.company',
      'common.physicalPerson',
      'common.status_notDeleted',
      'common.status_onlyDeleted',
      'reportMg.card_title',
      'reportMg.name_title',
      'reportMg.surname_title',
      'reportMg.fiscalcode_title',
      'reportMg.birthdate_title',
      'reportMg.email_title',
      'reportMg.cellphone_title',
      'reportMg.street_title',
      'reportMg.localita_title',
      'reportMg.province_title',
      'reportMg.zipcode_title',
      'reportMg.informativa_title',
      'reportMg.consenso1_title3',
      'reportMg.consenso2_title3',
      'reportMg.consenso_title_yes',
      'reportMg.consenso_title_no',
      'reportMg.currentdate_title',
      'reportMg.sign_title',
      'upload.upload_success',
      'upload.upload_error',
      'upload.type_error',
      'upload.choose_file',
      'upload.download_error'
    ]);


    //recupero dati
    let search = [
      {key: 'name',value: 'italia' },
      {key: 'flg_state',value: '0'}
    ];

    var CHECKSTORAGEAVILABILITY = this.srvCust.chackStorageAvailability(this.customerHostId);
    var COUNTRIES = this.srvCountry.list(null,null,search);
    var GETFILES = this.srvCust.getFiles(this.customerHostId,"moduli");
    var GETCARDSINFO = this.srvCust.getCards(this.customerHostId);
    var self = this;

    Observable.zip(
      CHECKSTORAGEAVILABILITY ,
      COUNTRIES,
      GETFILES,
      GETCARDSINFO,
      translateObs)
    .subscribe(([
      resCheck,
      resCountries,
      resGetFiles,
      resCardsInfo,
      t]) => {

          self.translations = t;

          self.cardInfo = resCardsInfo;

          if(resGetFiles && resGetFiles.history){
            self.currentExistingFiles = resGetFiles.history;

            if (resGetFiles.history.length > 0) {
              self.customerHasFiles.emit(true);
            }
          }

          let provinces: Observable<any>;

          if(resCountries){
            if(resCountries.data[0] !== null) {
              provinces = self.srvProvince.getAll(resCountries.data[0].id);
            } else {
              provinces = self.srvProvince.getAll(-1);
            }

            provinces.subscribe(resProvinces=>{
              if(resProvinces){
                for (const province of resProvinces) {
                  self.provinces.push({
                    value: province.id,
                    label: province.name
                  });
                }
              }

              if(this.basicInfo && this.cardInfo){

                let cust:mgCustomer = new mgCustomer();
                if(this.basicInfo.customerCode){
                  cust.customerId = +self.customerHostId;
                  cust.puntoVenditaPref = (this.basicInfo && this.basicInfo.preferred_store_id) ? this.basicInfo.preferred_store_id.toString() : "1";
                  cust.nome = this.basicInfo.name;
                  cust.cognome = this.basicInfo.surname;
                  cust.fiscalCode = this.basicInfo.fiscal_code;
                  cust.birthDate = this.basicInfo.birthday;
                  cust.sex = this.basicInfo.sex;
                  cust.mobile = this.basicInfo.phone_mobile;
                  cust.email = this.basicInfo.email_primary;
                  cust.toponym = (this.basicInfo && this.basicInfo.toponym_id) ? this.basicInfo.toponym_id.toString() : "1";
                  cust.address = this.basicInfo.address;
                  cust.addressNumber = this.basicInfo.address_number;
                  cust.comune = this.basicInfo.city;
                  cust.zipCode = this.basicInfo.zip_code;
                  cust.province = this.basicInfo.province_id;
                  cust.flgAuth1 = this.basicInfo.flag_privacy;
                  cust.flgAuth2 = this.basicInfo.flag_marketing_activities;
                  cust.flgAuth3 = this.basicInfo.flag_profiling;

                  //let card: CustomerCardListModel = null;
                  //prendo la prima che incontro non in blacklist che sono sicuro che è l'ultima associata.
                  for(var i = 0;i<this.cardInfo.length;i++){
                    if(this.cardInfo[i].flagBlackList!="1"){
                      this.card = this.cardInfo[i];
                      break;
                    }
                  }

                  /*
                  09-05-2022 
                  controllo aggiunto perchè in caso di blacklist non si vedeva l'upload moduli perchè non avevo info sulla carta e perciò 
                  andava in errore.
                  Adesso questo caso non si dovrebbe più presentare in quanto anche in caso di tutte carte in blacklist considero la prima
                  */
                  if(!this.card && this.cardInfo.length>0){
                    this.card = this.cardInfo[0];
                    this.show.available = false;
                    this.show.download = false;
                  }
                  else{
                    this.show.download = true;
                    if(resCheck && !resCheck.error){
                      self.show.available = true;
                    }
                    else{
                      self.show.available = false;
                    }
                  }

                  self.card = this.card;
                  var self2 = self;

                  let indexProvince = self.provinces.findIndex(x=>x.value == cust.province);
                  if(indexProvince>-1){
                    cust["provinceName"] = self.provinces[indexProvince].label;
                  }

                  
                  /* 
                  //if(self.card !== null){
                  09-05-2022 
                  Modificato perchè in caso di carta in blacklist valeva undefined e perciò passava il controllo, erroneamente. 
                  Tuttavia questo il caso non si dovrebbe più presentare in quanto anche in caso di tutte carte in blacklist considero la prima
                  */

                  if(self.card){
                    self.srvStoreCommon.getList(null,null,{id: this.card.store_id.toString()}).subscribe(res=>{

                      if(res && res.length && res.length>0){
                        cust["storeDescription"] = res[0].name;
                        cust["storeCode"] = res[0].code;
                      }

                      self2.customer = cust;
                      self2.show.customerInfo = true;
                    });

                    if(self.card.cardNo.length < 13){

                      this.barcodeCardNo = this.srvCommon.getCardWithCheckdigit(self.card.cardNo);

                      /*
                      this.srvLoyaltyReservations.getCardCheckDigit(self.card.cardNo).subscribe(res => {
                        //console.log('check digit res ', res);
                        if(res && res.length == 13){
                          this.barcodeCardNo = res;
                        }
                      });
                      */
                    }
                  }
                }
              }

            });
          }
        });
  }
  onClearUpload(){
    this.file = null;
  }
  onFileUpload(event, upload) {
    if(event.files[0].type == "application/pdf"){
        var self = this;
      setTimeout(function(){
        self.upload = upload;
        self.file = event.files[0];
      },100);
    }
    else{
      this.notifyService.add({ severity: 'error', detail: this.translations['upload.type_error'] });
    }

  }
  onClickScaricaModuloVuoto() {
    console.log('Genera report cliente - customer ');
    // Change report viewer options
    var options = new Stimulsoft.Viewer.StiViewerOptions();
    options.appearance.scrollbarsMode = true;
    options.appearance.fullScreenMode = true;


    this.viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);
    var stiReport = new Stimulsoft.Report.StiReport();

    stiReport.loadFile("./assets/report/InserimentoCliente.mrt");


    //negozio
    stiReport.dictionary.variables.getByName("var_store_name_val").valueObject = this.customer["storeDescription"];
    stiReport.dictionary.variables.getByName("var_store_code_val").valueObject = this.customer["storeCode"];

    //carta
    stiReport.dictionary.variables.getByName("var_card_title").valueObject = this.translations['reportMg.card_title'];
    //stiReport.dictionary.variables.getByName("barcode_img").value = this.getBarcodeImageByCardNo(this.card.cardNo);

    if(this.card.cardNo.length == 13){
      stiReport.dictionary.variables.getByName("barcode_img").value = this.getBarcodeImageByCardNo(this.card.cardNo);
    }else{
      stiReport.dictionary.variables.getByName("barcode_img").value = this.getBarcodeImageByCardNo(this.barcodeCardNo);
    }

    //info cliente
    stiReport.dictionary.variables.getByName("var_name_title").valueObject = this.translations['reportMg.name_title'];
    stiReport.dictionary.variables.getByName("var_name_val").valueObject = this.customer.nome;

    stiReport.dictionary.variables.getByName("var_surname_title").valueObject = this.translations['reportMg.surname_title'];
    stiReport.dictionary.variables.getByName("var_surname_val").valueObject = this.customer.cognome;

    stiReport.dictionary.variables.getByName("var_fiscalcode_title").valueObject = this.translations['reportMg.fiscalcode_title'];
    stiReport.dictionary.variables.getByName("var_fiscalcode_val").valueObject = this.customer.fiscalCode;

    stiReport.dictionary.variables.getByName("var_birthdate_title").valueObject = this.translations['reportMg.birthdate_title'];
    stiReport.dictionary.variables.getByName("var_birthdate_val").valueObject = moment(this.customer.birthDate).format("DD/MM/YYYY");

    stiReport.dictionary.variables.getByName("var_email_title").valueObject = this.translations['reportMg.email_title'];
    stiReport.dictionary.variables.getByName("var_email_val").valueObject = this.customer.email;

    stiReport.dictionary.variables.getByName("var_cellphone_title").valueObject =this.translations['reportMg.cellphone_title'];
    stiReport.dictionary.variables.getByName("var_cellphone_val").valueObject = this.customer.mobile;

    stiReport.dictionary.variables.getByName("var_street_title").valueObject = this.translations['reportMg.street_title'];
    stiReport.dictionary.variables.getByName("var_street_val").valueObject = this.customer.address + " " + this.customer.addressNumber;

    stiReport.dictionary.variables.getByName("var_localita_title").valueObject = this.translations['reportMg.localita_title'];
    stiReport.dictionary.variables.getByName("var_localita_val").valueObject = this.customer.comune;

    stiReport.dictionary.variables.getByName("var_province_title").valueObject = this.translations['reportMg.province_title'];
    stiReport.dictionary.variables.getByName("var_province_val").valueObject = this.customer["provinceName"] ? this.customer["provinceName"] : "";

    stiReport.dictionary.variables.getByName("var_zipcode_title").valueObject = this.translations['reportMg.zipcode_title'];;
    stiReport.dictionary.variables.getByName("var_zipcode_val").valueObject = this.customer.zipCode;

    //informativa
    stiReport.dictionary.variables.getByName("var_informativa_title").valueObject = this.translations['reportMg.informativa_title'];
    stiReport.dictionary.variables.getByName("var_informativa_val").valueObject = (this.customer.flgAuth1 == true || this.customer.flgAuth1 == "1") ? "X" : "";

    //consenso prima riga
    stiReport.dictionary.variables.getByName("var_consenso1_title1").valueObject = this.translations['reportMg.consenso_title_yes'];
    stiReport.dictionary.variables.getByName("var_consenso1_val1").valueObject = (this.customer.flgAuth2 == true || this.customer.flgAuth2 == "1") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso1_title2").valueObject = this.translations['reportMg.consenso_title_no'];
    stiReport.dictionary.variables.getByName("var_consenso1_val2").valueObject = (!this.customer.flgAuth2 || this.customer.flgAuth2 == "0") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso1_title3").valueObject = this.translations['reportMg.consenso1_title3'];

    //consenso seconda riga
    stiReport.dictionary.variables.getByName("var_consenso2_title1").valueObject = this.translations['reportMg.consenso_title_yes'];
    stiReport.dictionary.variables.getByName("var_consenso2_val1").valueObject = (this.customer.flgAuth3 == true || this.customer.flgAuth3 == "1") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso2_title2").valueObject = this.translations['reportMg.consenso_title_no'];
    stiReport.dictionary.variables.getByName("var_consenso2_val2").valueObject = (!this.customer.flgAuth3 || this.customer.flgAuth3 == "0") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso2_title3").valueObject = this.translations['reportMg.consenso2_title3'];

    //data e firma
    stiReport.dictionary.variables.getByName("var_currentdate_title").valueObject = this.translations['reportMg.currentdate_title'];
    stiReport.dictionary.variables.getByName("var_currentdate_val").valueObject = moment(new Date()).format("DD/MM/YYYY");
    stiReport.dictionary.variables.getByName("var_sign_title").valueObject = this.translations['reportMg.sign_title'];

    //consulta regolamento
    stiReport.dictionary.variables.getByName("var_read_rules_title").valueObject = "Consulta il regolamento e l'informativa privacy sul sito";
    stiReport.dictionary.variables.getByName("var_site_title").valueObject = "www.oasitigre.it";

    //copia punto vendita
    stiReport.dictionary.variables.getByName("var_copy_store_title").valueObject = "Copia per il punto vendita";

    //Render report
    stiReport.render();
    this.viewer.report = stiReport;

    // Export and Download to PDF
    this.viewer.report.exportDocumentAsync((pdfData) => {
      var buffer = Buffer.from(pdfData)
      var blob = new Blob([buffer], {type: "application/pdf"});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      var fileName = this.basicInfo ? (this.basicInfo.customerCode + "_" + moment(new Date()).format('DD_MM_YYYY') + ".pdf") : "report-customer.pdf";
      link.download = fileName;
      link.click();

      console.log("Rendered report saved into PDF-file.");
    }, Stimulsoft.Report.StiExportFormat.Pdf);
  }

  getBarcodeImageByCardNo(cardNo: string){

    var JsBarcode = require('jsbarcode')

    JsBarcode("#barcode", cardNo, {
      format: "EAN13",
      lineColor: "#000",
      width:2,
      height:40,
      displayValue: true
    });

    var svg = $("#barcode")[0];

    var xml = new XMLSerializer().serializeToString(svg);

    var base64 = 'data:image/svg+xml;base64,' + btoa(xml);

    return base64;
  }

  onClickSave(){

    if(this.file){

      if(this.file.type == "application/pdf"){
        var self = this;
        this.srvCust.uploadMgFile(this.file,this.customerHostId,"moduli").subscribe(res=>{

          if(res){
            self.notifyService.add({severity: 'success', detail: this.translations['upload.upload_success']});
            self.currentExistingFiles.unshift(res);
            this.customerHasFiles.emit(true);
          }
          else{
            self.notifyService.add({severity: 'error', detail: this.translations['upload.upload_error']});
            self.onClearUpload();
          }
          self.upload.clear();
          self.onClearUpload();
        });
      }

    }
  }
  onClickShowFile(currentExistingfile: CustomerFileUpload){
    var self = this;
    this.srvCust.getFileByBase64(this.customerHostId,currentExistingfile.storageFileName,"moduli").subscribe(res=>{
      if(res){              
        var blob = new Blob([res], {type: "application/pdf"});
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var fileName = currentExistingfile.originalFileName;
        link.download = fileName;            
        link.click();
      }
      else{
        self.notifyService.add({severity: 'error', detail: this.translations['upload.download_error']});
      }
    });

  }
  
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/upload-mg/uploadmg.component.ts